import { CustomerAction, CustomerActions, CustomerOldStock, CustomerOldStockItem } from '../model';
import { CustomerState, wrapStateWithCustomerNumber } from '../utils/url';
import { ResponsePayload } from '../model/request';

import createReducer from './createReducer';

export const customerOldStock = createReducer<CustomerState<CustomerOldStock>>({}, {
  [CustomerActions.FETCH_OLD_STOCK_SUCCESS](
    state: CustomerState<CustomerOldStock>,
    action: CustomerAction
  ) {
    return wrapStateWithCustomerNumber((
      action.payload as ResponsePayload<CustomerOldStock>
    ).data, state, undefined);
  },
  [CustomerActions.TOGGLE_ARRIVAL_CONFIRMATION_STATE_SUCCESS](
    state: CustomerState<CustomerOldStock>,
    action: CustomerAction
  ) {
    const item = (
      action.payload as ResponsePayload<CustomerOldStockItem>
    ).data;

    return wrapStateWithCustomerNumber(oldState => {
      if (!oldState) return

      const itemIndex = oldState.items.findIndex(s => s.eventId === item.eventId);

      if (itemIndex < 0) {
        return oldState;
      }

      return {
        ...oldState,
        items: [
          ...oldState.items.slice(0, itemIndex),
          {
            ...oldState.items[itemIndex],
            charged: item.charged,
          },
          ...oldState.items.slice(itemIndex + 1)
        ],
      }
    }, state, undefined);
  },
});
